import { Component, ElementRef, Injector, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { WebcomponentsService } from '@core/service/webcomponents.service';
import { ProductType } from '@core/model/enums';
import { show_popup, showPopupBase, TITLE_MENSAJE } from '@shared/utility/popup-error';

import { ROUTES_CONSTANTS } from '@shared/configs';

enum PRODUCT_TYPE_ENUMERATION {
  RAPIFLEX = 1,
}

const LOAN_PROCESS_CONSTANT = 'ON_GRAY_ZONE_PROCESS';
const DECLINED_STATUS_CONSTANT = 'DECLINED';
const POPUP_ERROR_CONSTANTS = {
  TITLE: 'Ups',
  MESSAGE: 'Algo salió mal. Por favor intenta de nuevo.',
};

@Component({
  selector: 'app-application-terms-and-conditions',
  templateUrl: './application-terms-and-conditions.component.html',
  styleUrls: ['./application-terms-and-conditions.component.scss'],
})
export class ApplicationTermsAndConditionsComponent implements OnInit {
  @ViewChild('applicationTermsRef', { static: false })
  public applicationTermsRef!: ElementRef;

  amount!: number;
  term!: number;
  quota!: number;
  firstPaymentDate!: string;
  productConditionId!: string;

  private readonly webComponentService: WebcomponentsService;
  private readonly router: Router;
  private readonly cookieService: CookieService;
  private readonly ngZone: NgZone;
  private readonly marketingEventService: MarketingEventService;

  constructor(private readonly injector: Injector) {
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.router = this.injector.get(Router);
    this.cookieService = this.injector.get(CookieService);
    this.ngZone = this.injector.get(NgZone);
    this.marketingEventService = this.injector.get(MarketingEventService);
  }

  public ngAfterViewInit(): void {
    const applicationTerms = this.applicationTermsRef.nativeElement;
    this.webComponentService.isLoaded$.subscribe({
      next: (loaded) => {
        if (loaded) {
          applicationTerms.ngElementStrategy?.componentRef?.instance?.build({
            config: {
              amount: this.amount,
              term: this.term,
              monthFee: this.quota,
              productType: PRODUCT_TYPE_ENUMERATION.RAPIFLEX,
              newLoan: true,
              productConditionId: this.productConditionId,
            },
            responseFunction: (result) => {
              this.ngZone.run(() => {
                if (result?.response?.state === LOAN_PROCESS_CONSTANT) {
                  this.marketingEventService.sendMarketingEvents(
                    MarketingEventEnumeration.LOAN_APPLICATION_ACCEPTED_RFYA
                  );
                  this.router.navigate([ROUTES_CONSTANTS.DISPERSION_METHOD]);
                } else if (result?.response?.state === DECLINED_STATUS_CONSTANT || result?.status < 500) {
                  this.marketingEventService.sendMarketingEvents(
                    MarketingEventEnumeration.LOAN_APPLICATION_REJECTED_RFYA
                  );
                  showPopupBase(TITLE_MENSAJE, result.response.navigableResponseDto.message).then(() => {
                    this.router.navigate([ROUTES_CONSTANTS.APPLICATION_REJECTION]);
                  });
                } else show_popup(POPUP_ERROR_CONSTANTS.TITLE, POPUP_ERROR_CONSTANTS.MESSAGE);
              });
            },
          });
        }
      },
    });
  }

  public ngOnInit(): void {
    this.amount = +(this.cookieService.get('applicationAmount') || sessionStorage.getItem('applicationAmount') || 0);
    this.term = +(this.cookieService.get('applicationTerm') || sessionStorage.getItem('applicationTerm') || 0);
    this.quota = +(this.cookieService.get('applicationQuota') || sessionStorage.getItem('applicationQuota') || 0);
    this.firstPaymentDate = this.cookieService.get('firstPaymentDate');
    this.productConditionId =
      this.cookieService.get('productConditionId') || sessionStorage.getItem('productConditionId') || ProductType.RFYA;
  }
}
